import React from 'react';
import { REGIME_LABEL } from '../../api/petAdapter';
import '../../styles/RegimeFilter.css';

/**
 * UI state space for the regime filter. Wider than the backend `Regime` enum:
 * 'todos' (no filter) and 'ambos' (FAT or FAD) are frontend-only sentinels that
 * AdotarCatalog translates to the `regimes` query param.
 */
export type RegimeFilterValue = 'todos' | 'FAT' | 'FAD' | 'ambos';

interface RegimeFilterProps {
  value: RegimeFilterValue;
  onChange: (next: RegimeFilterValue) => void;
}

const OPTIONS: { value: RegimeFilterValue; label: string; title?: string }[] = [
  { value: 'todos', label: 'Todos', title: 'Todos os animais disponíveis' },
  { value: 'FAT', label: 'FAT', title: REGIME_LABEL.FAT },
  { value: 'FAD', label: 'FAD', title: REGIME_LABEL.FAD },
  { value: 'ambos', label: 'Ambos', title: 'Disponível em FAT ou FAD' },
];

const RegimeFilter: React.FC<RegimeFilterProps> = ({ value, onChange }) => (
  <fieldset className="regime-filter">
    <legend className="regime-filter__legend">Por regime</legend>
    <div className="regime-filter__pills" role="radiogroup" aria-label="Filtro por regime">
      {OPTIONS.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={active}
            title={opt.title}
            className={`regime-filter__pill ${active ? 'is-active' : ''}`}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  </fieldset>
);

export default RegimeFilter;
